import React from 'react';
import styled from 'styled-components';

const SkipLink = () => (
  <StyledSkipLink href="#heroComponent" className="skip-link">
    Skip to main content
  </StyledSkipLink>
);

const StyledSkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 0;
  background-color: #f0f0f0;
  padding: 5px;
  z-index: 9999;
  &:focus {
    top: 0;
  }
`;

export default SkipLink;
